module.exports = __webpack_public_path__ + "static/media/logo-caddy-red.440fc2dd.png";